import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebAdminService } from 'src/app/main/web-admin/web-admin.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { ErrorModel } from 'src/app/core/models/error.model';

@Component({
  selector: 'app-sync-db',
  templateUrl: './sync-db.component.html',
  styleUrls: ['./sync-db.component.scss']
})
export class SyncDbComponent implements OnInit {
  messagem = null;

  formGroup: FormGroup = this.formBuilder.group({
    codigo: ['', Validators.compose([Validators.required])],
  });

  constructor(
      private formBuilder: FormBuilder,
      private webAdminService: WebAdminService,
      private layoutService: LayoutService,
  ) { }

  ngOnInit(): void {
  }

  get inputValue(): any {
    return this.formGroup.get('codigo').value;
  }

  submitForm(): void {
    this.messagem = null;

    if (!this.formGroup.valid) {
      this.messagem = 'preencha o campo com o id do card';
      return;
    }

    this.layoutService.loading();
    this.webAdminService
        .syncDbFromCard(this.inputValue)
        .subscribe(() => {
          this.messagem = 'DB atualizado com sucesso.';
          this.formGroup.reset();
        }, (error: ErrorModel) => {
          this.messagem = 'Falha ao atualizar DB a partir do pipefy.';
        })
        .add(() => {
          this.layoutService.loaded();
        });
  }

}
